import './ActionPopup.css';
import { Popup } from '@progress/kendo-react-popup';
import * as React from 'react';
import { Trip } from '.';
import { ILink } from '../../types/link';
import { ComposeEmail } from './ComposeEmail';
import { SetupNotifications } from './SetupNotifications';
import { openWindow } from '../../services/openWindow';
import { ComposeCarrierEmail } from './ComposeCarrierEmail';
import { OrderAuditLogGrid } from './OrderAuditLogGrid';
import AppTracking from './AppTracking';
import ExternalUrl from './ExternalUrl';
import CreateServiceException from './CreateServiceException';
import DispatchConfirmationDialog from './DispatchConfirmationDialog';
import { fetchApi } from '../../services/api';
import CarrierReviews from '../CarrierReviews';
import OutsideAlerter from '../../components/OutsideAlerter';
import Arrive from '../../components/Milestones/Arrive';
import Load from '../../components/Milestones/Load';
import Empty from '../../components/Milestones/Empty';
import Complete from '../../components/Milestones/Complete';
import { Button, ButtonHandle } from '@progress/kendo-react-buttons';
import { Link } from 'react-router-dom';
import { GridCustomCellProps } from '@progress/kendo-react-grid';

const ActionPopup = (props: GridCustomCellProps) => {

    const { dataItem }: { dataItem: Trip } = props;
    const anchor = React.useRef<ButtonHandle>(null);

    const [show, setShow] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [links, setLinks] = React.useState<ILink[]>([]);
    const [composeEmail, setComposeEmail] = React.useState<boolean>(false);
    const [setupNotifications, setSetupNotifications] = React.useState<boolean>(false);
    const [externalUrl, setExternalUrl] = React.useState<boolean>(false);
    const [composeCarrierEmail, setComposeCarrierEmail] = React.useState<boolean>(false);
    const [carrierReviews, setCarrierReviews] = React.useState<boolean>(false);
    const [orderAuditLog, setOrderAuditLog] = React.useState<boolean>(false);
    const [createException, setCreateException] = React.useState<boolean>(false);
    const [dispatchConfirmation, setDispatchConfirmation] = React.useState<boolean>(false);
    const [setupLink, setSetupLink] = React.useState<null | ILink>(null);
    const [orderAuditLink, setOrderAuditLink] = React.useState<null | ILink>(null);
    const [trackingLink, setTrackingLink] = React.useState<null | ILink>(null);
    const [arriveLink, setArriveLink] = React.useState<null | ILink>(null);
    const [loadLink, setLoadLink] = React.useState<null | ILink>(null);
    const [emptyLink, setEmptyLink] = React.useState<null | ILink>(null);
    const [completeLink, setCompleteLink] = React.useState<null | ILink>(null);

    const loadLinks = React.useCallback(() => {
        fetchApi('/api/Track/GridPopupLinks/', { OrderID: dataItem.OrderID ?? 0, TripID: dataItem.TripID }, 'POST')
            .then((response: { Links: ILink[] }) => {
                setLoading(false);
                setLinks(response.Links);
            }).catch(() => alert('Unable to load links'));
    }, [dataItem.OrderID, dataItem.TripID]);

    React.useEffect(() => {
        if (show) {
            loadLinks();
        }
    }, [show, loadLinks]);

    const viewQuote = () => {
        window.open((links.find((x) => x.Name === 'ViewQuote')).Link, '_blank');
    }

    const createQuote = (link: ILink) => {
        fetchApi(link.Link, {}, 'POST')
            .then((response: { QuoteID: number }) => {
                window.open(`/Quote/Index/${response.QuoteID}`, '_blank');
            })
            .catch(() => {
                alert("Unable to create quote!");
            });
    }

    const setCritical = (link: ILink) => {
        fetchApi(link.Link, {}, 'POST')
            .catch(() => {
                alert("Unable to mark critical!");
            });
    }

    return <td {...props.tdProps}>
        <Button
            togglable
            selected={show}
            style={{ float: 'left', marginRight: '5px' }}
            onClick={(e) => {
                setShow(prev => !prev);
                e.preventDefault();
            }}
            ref={anchor}
        >
            Action
        </Button>
        {dataItem.HasNotificationsSetup &&
            <div style={{ float: 'left' }}><a
                href="#"
                className="en-badge"
                onClick={(e) => {
                    setSetupNotifications(true);
                    e.preventDefault();
                }}
            >EN</a></div>}
        <Popup anchor={anchor.current?.element} show={show && loading == false} popupClass='popup-content'>
            <OutsideAlerter toggle={() => setShow(false)} style={{ display: 'contents' }} excludeElement={anchor.current?.element}>
                {links.find((x) => x.Name === 'OrderPlanning2') && <Link
                    to={links.find((x) => x.Name === 'OrderPlanning2').Link}
                >Dispatch</Link>}
                {links.find((x) => x.Name === 'GetArrive') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setShow(false);
                        setArriveLink(links.find((x) => x.Name === 'GetArrive'));
                        e.preventDefault();
                    }}
                >Arrive
                </a>}
                {links.find((x) => x.Name === 'GetLoad') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setShow(false);
                        setLoadLink(links.find((x) => x.Name === 'GetLoad'));
                        e.preventDefault();
                    }}
                >Load
                </a>}
                {links.find((x) => x.Name === 'GetEmpty') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setShow(false);
                        setEmptyLink(links.find((x) => x.Name === 'GetEmpty'));
                        e.preventDefault();
                    }}
                >Empty
                </a>}
                {links.find((x) => x.Name === 'GetComplete') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setShow(false);
                        setCompleteLink(links.find((x) => x.Name === 'GetComplete'));
                        e.preventDefault();
                    }}
                >Complete
                </a>}
                {links.find((x) => x.Name === 'VehicleMessage') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        openWindow((links.find((x) => x.Name === 'VehicleMessage')).Link);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Message
                </a>}
                {links.find((x) => x.Name === 'UploadAnImage2') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        openWindow((links.find((x) => x.Name === 'UploadAnImage2')).Link);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Documents
                </a>}
                {links.find((x) => x.Name === 'CarrierForm') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        openWindow((links.find((x) => x.Name === 'CarrierForm')).Link, 920, 1100);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Carrier Form
                </a>}
                {dataItem.CarrierPhone && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setCarrierReviews(true);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Carrier Reviews
                </a>}
                {links.find((x) => x.Name === 'MarkCritical') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setCritical(links.find((x) => x.Name === 'MarkCritical'));
                        setShow(false);
                        e.preventDefault();
                    }}
                >Mark Critical</a>}
                {links.find((x) => x.Name === 'UnMarkCritical') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setCritical(links.find((x) => x.Name === 'UnMarkCritical'));
                        setShow(false);
                        e.preventDefault();
                    }}
                >Un-Mark Critical</a>}
                {links.find((x) => x.Name === 'CarrierUpdateEmail') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setComposeCarrierEmail(true);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Request Update</a>}
                {dataItem.OrderID && dataItem.DispatchConfirmationStatus !== null && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setDispatchConfirmation(true);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Dispatch Confirmation</a>}
                {links.find((x) => x.Name === 'AppTracking') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setTrackingLink(links.find((x) => x.Name === 'AppTracking'));
                        setShow(false);
                        e.preventDefault();
                    }}
                >Setup Tracking
                </a>}
                {links.find((x) => x.Name === 'StatusUpdateEmail') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setComposeEmail(true);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Send Status Update</a>}
                {links.find((x) => x.Name === 'OrderNotifications') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setSetupNotifications(true);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Setup Notifications</a>}
                {links.find((x) => x.Name === 'ExternalURL') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setExternalUrl(true);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Add Tracking URL</a>}
                {links.find((x) => x.Name === 'OrderAuditLogs') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setOrderAuditLog(true);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Audit Logs</a>}
                <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        setCreateException(true);
                        setShow(false);
                        e.preventDefault();
                    }}
                >Create Exception</a>
                {links.find((x) => x.Name === 'ViewQuote') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        viewQuote();
                        setShow(false);
                        e.preventDefault();
                    }}
                >Open Quote</a>}
                {links.find((x) => x.Name === 'CreateQuote') && <a
                    href="#"
                    style={{ color: '#007bff' }}
                    onClick={(e) => {
                        createQuote(links.find((x) => x.Name === 'CreateQuote'));
                        setShow(false);
                        e.preventDefault();
                    }}
                >Create Quote</a>}
            </OutsideAlerter>
        </Popup>

        {composeEmail && <ComposeEmail
            CloseDialog={() => setComposeEmail(false)}
            SetupNotifications={(setupLink) => {
                setComposeEmail(false);
                setSetupLink(setupLink);
            }}
            OrderAuditLogs={(orderAuditLink) => {
                setComposeEmail(false);
                setOrderAuditLink(orderAuditLink);
            }}
            Link={(links.find((x) => x.Name === 'StatusUpdateEmail'))} />}
        {orderAuditLog && <OrderAuditLogGrid
            CloseDialog={() => setOrderAuditLog(false)}
            Link={(links.find((x) => x.Name === 'OrderAuditLogs'))} />}
        {createException && <CreateServiceException
            CloseDialog={() => setCreateException(false)}
            OrderID={dataItem.OrderID} />}
        {dispatchConfirmation && <DispatchConfirmationDialog
            CloseDialog={() => setDispatchConfirmation(false)}
            OrderID={dataItem.OrderID!} />}
        {composeCarrierEmail && <ComposeCarrierEmail
            CloseDialog={() => setComposeCarrierEmail(false)}
            Link={(links.find((x) => x.Name === 'CarrierUpdateEmail'))} />}
        {carrierReviews && <CarrierReviews
            CloseDialog={() => setCarrierReviews(false)}
            Name={dataItem.AssetName} PhoneNumber={dataItem.CarrierPhone} />}
        {setupNotifications && <SetupNotifications
            CloseDialog={() => setSetupNotifications(false)}
            Link={(dataItem.Links.find((x) => x.Name === 'OrderNotifications'))} />}
        {externalUrl && <ExternalUrl
            CloseDialog={() => setExternalUrl(false)}
            TripID={dataItem.TripID}
            ExternalUrl={dataItem.ExternalUrl} />}
        {setupLink && <SetupNotifications
            CloseDialog={() => setSetupLink(null)}
            Link={setupLink} />}
        {orderAuditLink && <OrderAuditLogGrid
            CloseDialog={() => setOrderAuditLink(null)}
            Link={orderAuditLink} />}
        {trackingLink && <AppTracking
            CloseDialog={() => setTrackingLink(null)}
            Link={trackingLink} />}
        {arriveLink && <Arrive
            CloseDialog={() => setArriveLink(null)}
            Link={arriveLink} />}
        {loadLink && <Load
            CloseDialog={() => setLoadLink(null)}
            Link={loadLink} />}
        {emptyLink && <Empty
            CloseDialog={() => setEmptyLink(null)}
            Link={emptyLink} />}
        {completeLink && <Complete
            CloseDialog={() => setCompleteLink(null)}
            Link={completeLink} />}
    </td>
}

export default React.memo(ActionPopup, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);
